import React, { useContext, useState } from 'react';
import moment from 'moment';
import SignaturePad from 'react-signature-canvas';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tooltip, InputLabel, Grid, TableCell, TableRow, Paper, FormHelperText, Typography, CircularProgress, IconButton, Hidden } from '@material-ui/core';

import EditAxle from './EditInspectionCheck/editAxel';

import ActionTakenModal from './EditInspectionCheck/actionTakenModal';
import ImageUploadModal from '../loanVehicleBooking/ImageUpload/ImageUploadModal';
import { EditInapectionContaxt, EditInspectionProvide } from './EditInspectionCheck/editInspectionProviderImports';
import { EditInspectionBreakTest } from './EditInspectionCheck/editInspectionbreakTest';
import { EditInspectionBrakePerformance } from './EditInspectionCheck/editInspectionBP';
import { EditInspectionRoadTest } from './EditInspectionCheck/editInspaectionRoadTest';
import { EditInspection } from './EditInspectionCheck/editInspection';
import { EditSInspectionSignOFF } from './EditInspectionCheck/editSignOff';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import ImageUpload from './InspectionImageUpload';
import ReturnToEngineer from './returnToEngineer';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
// import { getGenerateVehicleInspectionReportPdf } from '../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
// import { useToast } from '../../../../../Core/Hooks/useToast';
import { useHistory } from 'react-router-dom';
import DialogComp from '../../../Core/Modal/dialogModal';
import ConfirmationModal from '../../../Core/Controls/Dialog/ConfirmationModal';
import { DefaultButton, SecondaryButton, SelectBox, TextBox } from '../../../Core/FormInput';
import formatters from '../../../Core/Grid/inputFormatter';
import { BackButton, FailButton, MButton, NAButton, PassButton, RButton } from '../../../Core/FormInput/AppButton';
import { getGenerateVehicleInspectionReportPdf } from '../../../Core/Service/vehicleTabChecks';
import AppContext from '../../../App/AppContext';
import ModalHeaderInfo from '../../../Core/Controls/ModalHeaderInfo';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 16,
        padding: '8px 20px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '8px 20px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 15
    },
    table: {
        minWidth: '100%'
    },

    title: {
        color: '#f50057',
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8
    },
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // marginTop: 100
    },
    paper: {
        padding: theme.spacing(2),
        // color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.2)',
        width: '100%'
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        margin: 0,
        marginLeft: -4,
        marginBottom: 20
    },
    modalHeight: {
        height: `calc(100vh - 108px)`, // Default height calculation
        overflowY: 'auto', // Enable vertical scrolling
        '@media (min-width: 821px) and (max-width: 1024px)': {
            // height: `calc(100vh - 650px)` // Adjust height for devices between 821px and 1024px
            height: `100%`
        },
        '@media (min-width: 770px) and (max-width: 820px)': {
            // height: `calc(100vh - 450px)` // Adjust height for devices between 770px and 820px
            height: `100%`
        },
        '@media (min-width: 768px) and (max-width: 769px)': {
            // height: `calc(100vh - 280px)` // Adjust height for devices between 768px and 769px
            height: `100%`
        },
        '@media (min-width: 712px) and (max-width: 767px)': {
            // height: `calc(100vh - 400px)` // Adjust height for devices between 712px and 767px
            height: `100%`
        }
    }
}));

const CheckButtons = {
    S: PassButton,
    D: FailButton,
    M: MButton,
    N: NAButton,
    R: RButton
};

const CheckButtonsBorder = {
    D: 'red',
    M: 'orange',
    N: 'blue',
    S: 'green',
    R: 'red'
};

const IconColors = {
    fontSize: 25,
    color: 'white'
};
const fontColors = {
    fontSize: 16,
    color: 'white'
};

const ButtonColors = {
    D: { color: '#d32f2f', value: () => <ClearIcon style={IconColors} /> },
    M: { color: '#f57f17', value: () => <span style={fontColors}>M</span> },
    N: { color: '#3f51b5', value: () => <span style={fontColors}>N/A</span> },
    S: { color: '#388e3c', value: () => <DoneIcon style={IconColors} /> }
};

const EditVehicleDailyChecks = (props) => {
    const classes = useStyles();
    const {
        checkhaveAccess,
        widths,
        portalSettings,
        btnLoader,
        confirmBtnLoader,
        state,
        flags,
        isModal,
        handleInput,
        // clear,
        // GetTechnicianSign,
        onImageChange,
        // useDefaultSig,
        submitData,
        closeActionTakenhandle,
        closeReturnToEngModal,
        showReturnToEngModal,
        confirmHandle,
        sumbitImage,
        setState,
        // signCanvas,
        imgLoader,
        RemoveImage
    } = useContext(EditInapectionContaxt);
    // const { showToastSuccess, showToastError } = useToast();
    const history = useHistory();
    const [pdfLoading, setPdfLoading] = useState(false);
    const { showToast } = useContext(AppContext);
    const GlobalCss = withStyles((theme) => ({
        '@global': {
            '.MuiDialogContent-root': {
                padding: '10px',
                [theme.breakpoints.down('sm')]: {
                    padding: '0px' // Customize the padding for 'sm' and up screens
                }
            }
        }
    }))(() => null);
    const GenerateVehicleInspectionReportPdf = async () => {
        try {
            setPdfLoading(true);
            let res = await getGenerateVehicleInspectionReportPdf(props.checkID, props.displayCheck);

            if (res.success) {
                showToast('Invoice PDF Generated Successfully');
                history.goBack();
            } else {
                showToast(res.message);
            }
        } catch (err) {
            showToast(err?.message || 'Failed to generate PDF');
        } finally {
            setPdfLoading(false);
        }
    };

    let headerList = [
        {
            name: 'Registration Number',
            value: props?.data?.reg
        },
        { name: 'WIP No', value: props?.data?.wipNumber },
        { name: 'Customer', value: props?.data?.customerName },
        { name: 'Inspection Date', value: formatters.DateTimeFormatter(props?.data?.dateInspected) }
    ];

    return (
        <>
            <GlobalCss />
            <DialogComp onClose={props.onClose} title={'Signoff Inspection'} maxWidth="xl" fullWidth fullScreen>
                <div style={{ overflow: 'auto', padding: 10 }} className={classes.modalHeight}>
                    {!state.load ? (
                        <Grid container spacing={2} justify="space-between">
                            <Grid item container xs={12} spacing={2} alignItems="center" justify="space-between">
                                <Grid item md={6} lg={8} xl={8}>
                                    <Grid container alignItems="center" justify="flex-end" spacing={2}>
                                        <Hidden only={['md', 'lg', 'xl']}>
                                            {state.buttonList?.map((k) => {
                                                const Icon = ButtonColors[k.inspectionSheetCheckOptionCode].value;

                                                return (
                                                    <Grid item xs={4} sm={4} md={2} key={k.inspectionSheetCheckOptionCode}>
                                                        <IconButton
                                                            style={{
                                                                background: ButtonColors[k.inspectionSheetCheckOptionCode].color,
                                                                borderRadius: 0,
                                                                height: 30,
                                                                width: '100%',
                                                                padding: 10,
                                                                fontSize: 12,
                                                                color: 'white'
                                                            }}
                                                        >
                                                            {' '}
                                                            <div
                                                                style={{
                                                                    padding: 8,
                                                                    fontSize: 12,
                                                                    fontWeight: 600,
                                                                    color: 'white'
                                                                }}
                                                            >
                                                                {k.inspectionSheetCheckOptionDescription}
                                                            </div>
                                                        </IconButton>
                                                    </Grid>
                                                );
                                            })}
                                        </Hidden>
                                        <Hidden only={['sm', 'xs']}>
                                            {state.buttonList?.map((k) => {
                                                const Icon = ButtonColors[k.inspectionSheetCheckOptionCode].value;

                                                return (
                                                    <Grid item xs={4} sm={4} md={4} xl={2} lg={3} key={k.inspectionSheetCheckOptionCode}>
                                                        <IconButton
                                                            style={{
                                                                background: ButtonColors[k.inspectionSheetCheckOptionCode].color,
                                                                borderRadius: 0,
                                                                height: 20,
                                                                width: '100%',
                                                                padding: 10,
                                                                fontSize: 12,
                                                                color: 'white'
                                                            }}
                                                        >
                                                            <Icon /> {/* Render the icon component here */}
                                                            <div
                                                                style={{
                                                                    padding: 8,
                                                                    fontSize: 13,
                                                                    fontWeight: 600,
                                                                    color: 'white'
                                                                }}
                                                            >
                                                                {k.inspectionSheetCheckOptionDescription}
                                                            </div>
                                                        </IconButton>
                                                    </Grid>
                                                );
                                            })}
                                        </Hidden>
                                    </Grid>
                                </Grid>
                                {flags.generateDocument && (
                                    <Grid item md={5} lg={3} xl={3}>
                                        <SecondaryButton
                                            onClick={GenerateVehicleInspectionReportPdf}
                                            isBtnLoader={pdfLoading}
                                            disabled={pdfLoading}
                                            forceEnabled={true}
                                            icon={PictureAsPdfIcon}
                                        >
                                            Generate PDF
                                        </SecondaryButton>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item xs={8}>
                                <ModalHeaderInfo List={headerList} />
                            </Grid>

                            {/* {flags.displayMileage && (
                                <Grid item xs={6} sm={3} md lg={2} xl>
                                    <InputLabel shrink>Odometer Reading (KM)</InputLabel>
                                    <TextBox
                                        type="number"
                                        placeholder="Current Mileage"
                                        name="vehicleDailyCheckMileage"
                                        // name="vehicleDailyCheckMileage"
                                        onChange={handleInput}
                                        value={state.vehicleDailyCheckMileage}
                                        // value={state.vehicleDailyCheckMileage}
                                        isDisabled
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6} sm={12} md lg={2} xl>
                                <InputLabel shrink>Check carried out by</InputLabel>
                                <TextBox
                                    placeholder="Check carried out by"
                                    name="vehicleDailyCheckCheckerName"
                                    value={state.vehicleDailyCheckCheckerName}
                                    onChange={handleInput}
                                    disabled
                                    isDisabled
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={12} lg={4} className="mandatory-fields">
                                <InputLabel shrink>Slippage Reason</InputLabel>
                                <SelectBox
                                    List={state.slippageReasons}
                                    name="vehicleInspectionSlippageReasonID"
                                    onChange={handleInput}
                                    value={state.vehicleInspectionSlippageReasonID}
                                />
                            </Grid>
                            {/* Inspections */}
                            <EditInspection classes={classes} StyledTableCell={StyledTableCell} StyledTableRow={StyledTableRow} CheckButtons={CheckButtons} />
                            {/* Tyre checks column */}
                            {flags.displayTyres && (
                                <Grid item container direction="row" xs={12} sm={12}>
                                    <EditAxle state={state} classes={classes} vehicleNoOfAxles={state.vehicleNoOfAxles} />
                                </Grid>
                            )}
                            {flags.displayBrakeTest && <EditInspectionBreakTest classes={classes} />}
                            {flags.displayBrakePerformance && <EditInspectionBrakePerformance classes={classes} />}
                            {flags.displayRoadTest && <EditInspectionRoadTest classes={classes} />}
                            {/* Vehicle SignOff page */}
                            <Grid item container xs={12}>
                                <Paper className={classes.paper}>
                                    <Grid container xs={12}>
                                        <h3 className={classes.headings}>Vehicle Inspector</h3>
                                    </Grid>
                                    <Grid container xs={12}>
                                        <div
                                            className={classes.headings}
                                            style={{ marginTop: -20 }}
                                            dangerouslySetInnerHTML={{ __html: portalSettings.portalSettingTechnicianDeclaration }}
                                        />
                                    </Grid>
                                    <Grid container spacing={1} justify="space-between">
                                        <Grid item container spacing={1} xs={12} md={6}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <InputLabel shrink>Vehicle Checker Comment</InputLabel>
                                                <Typography variant="button">{state.vehicleInspectionInspectionComment}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item container spacing={0} xs={12} md={6}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <InputLabel shrink>Signature</InputLabel>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            right: 0
                                                        }}
                                                    ></div>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            right: 5,
                                                            bottom: 0,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-end'
                                                        }}
                                                    >
                                                        <Typography variant="body1">{state.vehicleDailyCheckCheckerName}</Typography>
                                                        <Typography variant="button">
                                                            {moment(state.vehicleInspectionDateInspected).format('DD/MM/YYYY HH:mm')}
                                                        </Typography>
                                                    </div>

                                                    {state.imgtechniciansign ? (
                                                        <div className="userSign" style={{
                                                            position: 'absolute',
                                                            top: 15,
                                                            width: '100%'
                                                        }}>
                                                            <div className='signatureCanvas'>
                                                                <img
                                                                    src={state.imgtechniciansign}
                                                                    style={{ width: '100%', height: '100%' }}
                                                                    alt="my signature"
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="userSign" style={{
                                                            position: 'absolute',
                                                            top: 15,
                                                            width: '100%'
                                                        }}>
                                                            <div className='signatureCanvas'>
                                                                <Typography variant="button" style={{ textAlign: 'center' }}>
                                                                    No Signature Found
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <h5 className={classes.headings} style={{ height: 20 }}>
                                            &nbsp;
                                        </h5>
                                    </Grid>
                                </Paper>
                            </Grid>
                            {/* {(checkhaveAccess?.CanUpdateVehicleInspections ||
                                flags.displayCustomerDeclaration === 1 ||
                                flags.displayCustomerDeclaration === 2) &&  */}
                            <EditSInspectionSignOFF classes={classes} />
                            <Grid item container spacing={2} xs={12} lg={12}>
                                {(state.vehicleInspectionStatusID === 3 || state.vehicleInspectionStatusID === 2 || state.vehicleInspectionStatusID === 1) && (
                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                        <SecondaryButton onClick={showReturnToEngModal} fullWidth>
                                            Return To Engineer
                                        </SecondaryButton>
                                    </Grid>
                                )}
                                {state.isSignOff || state.vehicleInspectionStatusID === 2 ? null : (
                                    <>
                                        {!state.hideSignOff ||
                                            (true && (
                                                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                    {/* {state.isCustomerSignOff ? (
                                            <SecondaryButton
                                                isBtnLoader={btnLoader}
                                                onClick={confirmHandle}
                                                disabled={!checkhaveAccess?.CanUpdateVehicleInspections}
                                            >
                                                Customer Sign Off
                                            </SecondaryButton> */}
                                                    {/* // ) : ( */}
                                                    <DefaultButton
                                                        isBtnLoader={btnLoader}
                                                        onClick={confirmHandle}
                                                        fullWidth
                                                        // color="success"
                                                        style={{ background: '#4caf50', color: 'white' }}
                                                        disabled={
                                                            !checkhaveAccess?.CanUpdateVehicleInspections &&
                                                            flags.displayCustomerDeclaration !== 1 &&
                                                            flags.displayCustomerDeclaration !== 2
                                                        }
                                                    >
                                                        Sign Off
                                                    </DefaultButton>
                                                    {/* )} */}
                                                </Grid>
                                            ))}
                                    </>
                                )}

                                <Grid
                                    item
                                    xs={12}
                                    sm={state.isSignOff || state.vehicleInspectionStatusID === 2 ? 12 : state.hideSignOff ? 12 : 6}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                >
                                    <SecondaryButton onClick={() => props.onClose()} fullWidth>
                                        Cancel
                                    </SecondaryButton>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ height: 160 }}>&nbsp;</div>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : (
                        <div className={classes.loader}>
                            <CircularProgress color="secondary" />
                        </div>
                    )}
                    {/* Checks Table */}

                    {isModal.actionTaken ? (
                        <DialogComp title="Defect Action" onClose={() => closeActionTakenhandle(false)} maxWidth="md" overflow="auto" fullWidth>
                            <ActionTakenModal selectedCheck={isModal.selectedCheck} onClose={closeActionTakenhandle} />
                        </DialogComp>
                    ) : null}

                    {isModal.showConfirm ? (
                        <DialogComp
                            title={`Confirm ${state.isCustomerSignOff ? 'Customer' : ''} Sign Off`}
                            onClose={() => closeActionTakenhandle(false)}
                            maxWidth="sm"
                        >
                            <ConfirmationModal
                                message={`Please note that you will not be able to make any changes once submitted. Click the Confirm button to proceed or Cancel to abort.`}
                                handleSubmit={submitData}
                                handleCancel={() => closeActionTakenhandle(false)}
                                title={`Confirm ${state.isCustomerSignOff ? 'Customer' : ''} Sign Off`}
                                isBtnLoader={confirmBtnLoader}
                            />
                        </DialogComp>
                    ) : null}
                    {state.showImageModal ? (
                        // <DialogComp title="Upload Image" onClose={() => setState((st) => ({ ...st, show: false }))} maxWidth="lg">
                        // <ImageModal
                        //     images={state.selectedImages}
                        //     onImageChange={onImageChange}
                        //     submitImage={sumbitImage}
                        //     disabled={state.isSignOff}
                        //     onClose={() => setState((st) => ({ ...st, showImageModal: false }))}
                        //     maxNumber={10}
                        // />
                        <ImageUpload
                            disabled={state.isDisabled}
                            state={state}
                            isAPI={state.fromApi}
                            onImageChange={onImageChange}
                            RemoveImage={RemoveImage}
                            submitImage={sumbitImage}
                            onClose={() => setState((st) => ({ ...st, showImageModal: false }))}
                            maxNumber={10}
                            loader={false}
                        />
                    ) : // </DialogComp>
                        null}
                    {isModal.returnToEngModalShow ? (
                        <DialogComp title="Return To Engineer" onClose={() => closeReturnToEngModal(false)} maxWidth="md" overflow="auto" fullWidth>
                            <ReturnToEngineer onClose={closeReturnToEngModal} vehicleInspectionID={state.vehicleInspectionID} />
                        </DialogComp>
                    ) : null}
                </div>
            </DialogComp>
        </>
    );
};

export const EditVehicleInspection = (props) => {
    return (
        <EditInspectionProvide {...props}>
            <EditVehicleDailyChecks {...props} />
        </EditInspectionProvide>
    );
};
